import { render } from "./agencyDetails.vue?vue&type=template&id=68ad8dda&ts=true"
import script from "./agencyDetails.vue?vue&type=script&lang=ts"
export * from "./agencyDetails.vue?vue&type=script&lang=ts"

import "./agencyDetails.vue?vue&type=style&index=0&id=68ad8dda&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__